webpackJsonp([231866196430535],{

/***/ 470:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _components = __webpack_require__(3);
	
	var _marketing = __webpack_require__(8);
	
	var _blog = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Overview = function (_React$Component) {
	  _inherits(Overview, _React$Component);
	
	  function Overview(props) {
	    _classCallCheck(this, Overview);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  Overview.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'DocPage' },
	      _react2.default.createElement(_components.StripeBG, { bg2: "white", style: 'purple' }),
	      _react2.default.createElement(_marketing.Navbar, { className: 'grid-restrain' }),
	      _react2.default.createElement(
	        'section',
	        { className: 'grid-restrain grid-row full-8' },
	        _react2.default.createElement(_blog.DocToc, null),
	        _react2.default.createElement(
	          'div',
	          { className: 'content markdown-doc grid-item' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'title' },
	            'Flow Control'
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              'Using Flow Control, you can add statements for decision making and error handling within your tests.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement('img', { src: 'https://res.cloudinary.com/snaptest/image/upload/v1532872070/docs/Flow%20Control/Screen_Shot_2018-07-10_at_8.47.17_PM.png', style: { "max-width": "400px" } })
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'A use case is to scrape data.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement('img', { src: 'https://res.cloudinary.com/snaptest/image/upload/v1532873873/docs/Flow%20Control/Screen_Shot_2018-07-29_at_9.17.28_AM.png', style: { "max-width": "400px" } })
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Then export the results to CSV or jSON.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement('img', { src: 'https://res.cloudinary.com/snaptest/image/upload/v1532872070/docs/Flow%20Control/Screen_Shot_2018-07-05_at_11.00.13_PM.png', style: { "max-width": "400px" } })
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'You can indent and un-indent actions for better visualization.'
	            ),
	            _react2.default.createElement(
	              'ul',
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                'Select the action or actions.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Click indent or un-indent.'
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement('img', { src: 'https://res.cloudinary.com/snaptest/image/upload/v1533088748/docs/Indenting/Screen_Shot_2018-07-31_at_8.58.53_PM.png', style: { "max-width": "400px" } })
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Overview;
	}(_react2.default.Component);
	
	exports.default = Overview;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-doc-flow-control-js-7fdafd65c4b3126d9df7.js